import { anexoUpdatedFields } from './anexoUpdatedFields';
const now = new Date();
export const ENROLLMENT_YEAR = now.getFullYear() + (now.getMonth() >= 3 ? 1 : 0);

// TamaÃ±o general de lo que completan las familias. Afecta la vista y el PDF.
// SubÃ­ o bajÃ¡ este valor para ajustar todos los campos de una vez.
export const USER_FIELD_FONT_SCALE = 1.3;

// Coordenadas originales del Word/PDF: terminan antes de la "l" de "los".
// Se reutilizan en la vista y en la descarga para que no se desalineen.
const contractClause1Year = {
  id: "contract-clause-1",
  text: String(ENROLLMENT_YEAR),
  x: 296.69,
  top: 160.46,
  width: 22.1,
  height: 11.04,
  fontSize: 11.04,
  fontFamily: "Times New Roman",
  fontWeight: 400,
  pdfFont: "times",
  clear: true,
};

const contractDivisionLabelClear = {
  id: "contract-division-label-clear",
  text: "",
  x: 356,
  top: 177,
  width: 45,
  height: 15,
  fontSize: 11,
  fontFamily: "Times New Roman",
  fontWeight: 400,
  pdfFont: "times",
  clear: true,
};

const contractDivisionLabel = {
  id: "contract-division-label",
  text: "división.",
  x: 409,
  top: 177,
  width: 45,
  height: 15,
  fontSize: 11,
  fontFamily: "Times New Roman",
  fontWeight: 400,
  pdfFont: "times",
  clear: true,
};

// Estas listas son la Ãºnica fuente de coordenadas. La descarga reutiliza
// exactamente los mismos valores que se ven en pantalla.
const solicitudPage1PreviewOverlays = [
  {
    id: "solicitud-cycle-heading",
    text: String(ENROLLMENT_YEAR),
    x: 506,
    top: 139,
    width: 39,
    height: 14,
    fontSize: 15,
    fontFamily: "Times New Roman",
    fontWeight: 900,
    pdfFont: "timesBold",
  },
];

const solicitudPage2PreviewOverlays = [
  contractClause1Year,
  {
    id: "contract-clause-3",
    text: String(ENROLLMENT_YEAR),
    x: 359,
    top: 292,
    width: 24,
    height: 14,
    fontSize: 11,
    fontFamily: "Times New Roman",
    fontWeight: 400,
    pdfFont: "times",
    clear: true,
  },
  contractDivisionLabelClear,
  contractDivisionLabel,
];

const anexoPage1PreviewOverlays = [
  {
    id: "anexo-cycle-heading",
    text: String(ENROLLMENT_YEAR),
    x: 346.75,
    top: 103.82,
    width: 37,
    height: 14.04,
    fontSize: 15.04,
    fontFamily: '"Courier New", Courier, monospace',
    fontWeight: 900,
    pdfFont: "sourceCourierNew",
    clear: true,
  },
  {
    id: "anexo-student-dni-line-clear",
    text: "",
    x: 56,
    top: 158,
    width: 310,
    height: 28,
    fontSize: 1,
    fontFamily: "Times New Roman",
    fontWeight: 400,
    pdfFont: "times",
    clear: true,
  },
  {
    id: "anexo-student-dni-label",
    text: "DNI.",
    x: 56,
    top: 164,
    width: 38,
    height: 16,
    fontSize: 14,
    fontFamily: '"Courier New", Courier, monospace',
    fontWeight: 900,
    pdfFont: "courier",
  },
  {
    id: "anexo-guardian-1-dotted-line-clear",
    text: "",
    x: 280,
    top: 646,
    width: 256,
    height: 25,
    fontSize: 1,
    fontFamily: "Times New Roman",
    fontWeight: 400,
    pdfFont: "times",
    clear: true,
  },
  {
    id: "anexo-guardian-2-dotted-line-clear",
    text: "",
    x: 280,
    top: 735,
    width: 256,
    height: 25,
    fontSize: 1,
    fontFamily: "Times New Roman",
    fontWeight: 400,
    pdfFont: "times",
    clear: true,
  },
];

const withPdfBackground = (previewOverlays, ids) =>
  previewOverlays.map((overlay) =>
    ids.includes(overlay.id) ? { ...overlay, clear: true } : overlay
  );

const text = (id, label, page, x, top, width, height = 13, fontSize = 8.5, maxLength, align) => {
  const userFontSize = fontSize * USER_FIELD_FONT_SCALE;
  // En el bloque superior los rótulos terminan demasiado cerca de sus valores.
  // Corrige tanto la vista como el PDF: corre el inicio del campo y conserva su
  // extremo derecho para dejar una separación visible después de cada etiqueta.
  const labelGap = page === 0 && top < 330 ? Math.min(4, Math.max(0, width - 10)) : 0;

  return {
    id,
    label,
    page,
    x: x + labelGap,
    top,
    width: width - labelGap,
    height,
    fontSize: userFontSize,
    // No limitar el texto según una estimación de caracteres por ancho. Esa
    // cuenta era demasiado conservadora y bloqueaba datos válidos (por ejemplo,
    // localidades o lugares de trabajo compuestos). Al generar el PDF,
    // `fitText` reduce la tipografía de forma controlada para que el valor
    // completo entre en el espacio disponible. Sólo los campos que reciben un
    // máximo explícito (como las divisiones de tres caracteres) se restringen.
    maxLength,
    align,
  };
};

const boxedText = (...args) => ({ ...text(...args), align: "center", variant: "box" });

const checkbox = (id, label, page, x, top, width = 12, height = 12, group) => ({
  id,
  label,
  page,
  type: "checkbox",
  group,
  x,
  top,
  width,
  height,
});

const solicitudFields = [
  text("student_name", "Apellido y nombre del alumno/a", 0, 164, 169, 355),
  text("birth_place", "Lugar de nacimiento", 0, 176, 192, 196),
  text("birth_date", "Fecha de nacimiento", 0, 414, 192, 106),
  text("student_dni", "DNI del alumno/a", 0, 92, 215, 116),
  text("nationality", "Nacionalidad", 0, 264, 215, 83),
  text("blood_group", "Grupo sanguíneo", 0, 428, 215, 85),
  text("address", "Domicilio", 0, 119, 238, 173),
  text("address_number", "Número de domicilio", 0, 313, 238, 45),
  text("address_floor", "Piso", 0, 395, 238, 36),
  text("address_apartment", "Departamento", 0, 466, 238, 37),
  text("locality", "Localidad", 0, 120, 261, 138),
  text("postal_code", "Código postal", 0, 288, 261, 39),
  text("province", "Provincia", 0, 397, 261, 120),
  text("home_phone", "Teléfono de la casa", 0, 180, 284, 101),
  text("alternate_phone", "Teléfono alternativo", 0, 342, 307, 191),
  text("initial_enrollment_date", "Fecha de inscripción inicial", 0, 178, 330, 100),
  checkbox("initial_room_3", "Sala 3 años", 0, 72, 363, 7, 7, "initial-room"),
  checkbox("initial_room_4", "Sala 4 años", 0, 72, 378, 7, 7, "initial-room"),
  checkbox("initial_room_5", "Sala 5 años", 0, 72, 395, 7, 8, "initial-room"),
  text("primary_enrollment_date", "Fecha de inscripción primaria", 0, 310, 427, 162),
  checkbox("primary_grade_1", "Primer grado", 0, 114, 449, 13, 13, "primary-grade"),
  checkbox("primary_grade_2", "Segundo grado", 0, 114, 466, 13, 13, "primary-grade"),
  checkbox("primary_grade_3", "Tercer grado", 0, 114, 485, 13, 13, "primary-grade"),
  checkbox("primary_grade_4", "Cuarto grado", 0, 221, 449, 13, 13, "primary-grade"),
  checkbox("primary_grade_5", "Quinto grado", 0, 221, 466, 13, 13, "primary-grade"),
  checkbox("primary_grade_6", "Sexto grado", 0, 221, 487, 13, 14, "primary-grade"),
  text("secondary_enrollment_date", "Fecha de inscripción secundaria", 0, 319, 518, 143),
  boxedText("secondary_division_1", "División de primer año secundario", 0, 148, 539, 13, 13, 9, 3),
  boxedText(
    "secondary_division_2",
    "División de segundo año secundario",
    0,
    148,
    560,
    13,
    13,
    9,
    3
  ),
  boxedText("secondary_division_3", "División de tercer año secundario", 0, 148, 578, 13, 13, 9, 3),
  boxedText("secondary_division_4", "División de cuarto año secundario", 0, 338, 539, 13, 13, 9, 3),
  boxedText("secondary_division_5", "División de quinto año secundario", 0, 338, 558, 13, 13, 9, 3),
  boxedText("secondary_division_6", "División de sexto año secundario", 0, 338, 577, 13, 13, 9, 3),
  text("baptism_place", "Lugar de bautismo", 0, 172, 644, 102, 18, 7.5),
  text("baptism_locality", "Localidad de bautismo", 0, 277, 644, 104, 18, 7.5),
  text("baptism_province", "Provincia de bautismo", 0, 384, 644, 104, 18, 7.5),
  text("baptism_date", "Fecha de bautismo", 0, 490, 644, 80, 18, 7.5),
  text("communion_place", "Lugar de primera comunión", 0, 172, 665, 102, 18, 7.5),
  text("communion_locality", "Localidad de primera comunión", 0, 277, 665, 104, 18, 7.5),
  text("communion_province", "Provincia de primera comunión", 0, 384, 665, 104, 18, 7.5),
  text("communion_date", "Fecha de primera comunión", 0, 490, 665, 80, 18, 7.5),
  text("confirmation_place", "Lugar de confirmación", 0, 172, 686, 102, 18, 7.5),
  text("confirmation_locality", "Localidad de confirmación", 0, 277, 686, 104, 18, 7.5),
  text("confirmation_province", "Provincia de confirmación", 0, 384, 686, 104, 18, 7.5),
  text("confirmation_date", "Fecha de confirmación", 0, 490, 686, 80, 18, 7.5),
  text("guardian_1_name", "Apellido y nombre del responsable 1", 0, 49, 741, 202),
  text("guardian_2_name", "Apellido y nombre del responsable 2", 0, 286, 741, 237),
  text(
    "guardian_1_relationship",
    "Carácter de la representación (Padre / Madre) responsable 1",
    0,
    49,
    773,
    217
  ),
  text(
    "guardian_2_relationship",
    "Carácter de la representación (Padre / Madre) responsable 2",
    0,
    293,
    773,
    218
  ),
  // Datos de los responsables: se amplían 12 puntos sin invadir la otra columna.
  text("guardian_1_profession", "Profesión responsable 1", 0, 103, 794, 157),
  text("guardian_2_profession", "Profesión responsable 2", 0, 351, 794, 192),
  text("guardian_1_workplace", "Lugar de trabajo responsable 1", 0, 142, 815, 118),
  text("guardian_2_workplace", "Lugar de trabajo responsable 2", 0, 395, 815, 152),
  text("guardian_1_phone", "Teléfono responsable 1", 0, 101, 835, 159),
  text("guardian_2_phone", "Teléfono responsable 2", 0, 348, 835, 174),
  text("guardian_1_dni", "DNI responsable 1", 0, 74, 856, 179),
  text("guardian_2_dni", "DNI responsable 2", 0, 322, 856, 197),
  text("guardian_1_email", "Correo electrónico responsable 1", 0, 75, 877, 179),
  text("guardian_2_email", "Correo electrónico responsable 2", 0, 323, 877, 192),
  text("contract_guardian", "Representante en el contrato", 1, 310, 83, 154, 15, 9.5),
  text("contract_student", "Alumno/a en el contrato", 1, 88, 102, 160, 15, 9.5),
  text("contract_course", "Curso indicado en el contrato", 1, 297, 178, 105, 14, 9.5),
  text("contract_division", "División indicada en el contrato", 1, 461, 178, 30, 14, 9.5),
  text("contract_clarification", "Aclaración del responsable", 1, 280, 861, 270, 15, 9.5),
  text("contract_dni", "DNI del responsable", 1, 113, 920, 109, 15, 9.5),
  text(
    "contract_relationship",
    "Carácter de la representación (Padre / Madre) del contrato",
    1,
    208,
    941,
    311,
    15,
    9.5
  ),
].map((field) => ({ ...field, fontWeight: 700, pdfFont: "timesBold" }));

const anexoFields = [
  text("student_name_first_line", "Apellido y nombre del alumno/a", 0, 300, 133, 244, 16, 10.5),
  text("student_dni", "DNI del alumno/a", 0, 100, 164, 110, 16, 10.5),
  text("authorized_1_name", "Apellido y nombre autorizado/a 1", 0, 199, 551, 337, 16, 9.5),
  text("authorized_1_dni", "DNI autorizado/a 1", 0, 114, 576, 92, 16, 9.5),
  text("authorized_1_phone", "Celular autorizado/a 1", 0, 301, 576, 128, 16, 9.5),
  text("authorized_2_name", "Apellido y nombre autorizado/a 2", 0, 199, 602, 337, 16, 9.5),
  text("authorized_2_dni", "DNI autorizado/a 2", 0, 114, 627, 92, 16, 9.5),
  text("authorized_2_phone", "Celular autorizado/a 2", 0, 304, 627, 133, 16, 9.5),
  text("transport_name", "Nombre del transporte escolar", 0, 187, 652, 287, 16, 9.5),
  text(
    "transport_driver",
    "Apellido y nombre de quien realiza el transporte",
    0,
    196,
    677,
    331,
    16,
    9.5
  ),
  text("transport_dni", "DNI del transporte escolar", 0, 114, 703, 92, 16, 9.5),
  text("transport_phone", "Celular del transporte escolar", 0, 301, 703, 150, 16, 9.5),
  text(
    "guardian_clarification",
    "Aclaración y DNI del responsable",
    0,
    280,
    747,
    182,
    16,
    9.5,
    undefined,
    "center"
  ),
  text("guardian_relationship", "Carácter de la representación (Padre / Madre)", 0, 212, 791, 308, 16, 9.5),
].map((field) => ({ ...field, fontWeight: 700, pdfFont: "timesBold" }));

export const documentConfigs = {
  solicitud: {
    title: `Solicitud de inscripción ${ENROLLMENT_YEAR} | Sagrado Corazón`,
    heading: "Solicitud de inscripción",
    description: "Completá los campos directamente sobre el documento original.",
    // Modelo entregado por la institución para el ciclo 2027. Los años se
    // actualizan puntualmente encima de sus lugares impresos para no exigir
    // un nuevo archivo cuando cambia el ciclo lectivo.
    pdfUrl: "/documentos-inscripcion-2027/solicitud-inscripcion-2027.pdf",
    emptyPdfName: `Solicitud-inscripcion-ISC-ciclo-${ENROLLMENT_YEAR}-vacia.pdf`,
    completedPdfName: `Solicitud-inscripcion-ISC-ciclo-${ENROLLMENT_YEAR}-completa.pdf`,
    pages: [
      {
        imageUrl: "/documentos-inscripcion/solicitud-inscripcion-screen-1.png",
        width: 612.12,
        height: 1008.12,
        previewOverlays: solicitudPage1PreviewOverlays,
        overlays: withPdfBackground(solicitudPage1PreviewOverlays, ["solicitud-cycle-heading"]),
      },
      {
        imageUrl: "/documentos-inscripcion-2027/solicitud-inscripcion-2027-screen-2.png",
        width: 612.12,
        height: 1008.12,
        previewOverlays: solicitudPage2PreviewOverlays,
        overlays: withPdfBackground(solicitudPage2PreviewOverlays, [
          "contract-clause-1",
          "contract-clause-3",
        ]),
      },
    ],
    fields: solicitudFields,
  },
  anexo: {
    title: `Anexo de inscripción ${ENROLLMENT_YEAR} | Sagrado Corazón`,
    heading: "Anexo de inscripción",
    description: "Completá los campos directamente sobre el documento original.",
    pdfUrl: "/documentos-inscripcion/anexo-dos-responsables.pdf",
    emptyPdfName: `Anexo-ficha-inscripcion-ISC-ciclo-${ENROLLMENT_YEAR}-vacio.pdf`,
    completedPdfName: `Anexo-ficha-inscripcion-ISC-ciclo-${ENROLLMENT_YEAR}-completo.pdf`,
    pages: [
      {
        imageUrl: "/documentos-inscripcion/anexo-dos-responsables.png",
        width: 595.32,
        height: 842.04,
        previewOverlays: anexoPage1PreviewOverlays,
        overlays: anexoPage1PreviewOverlays,
      },
    ],
    fields: anexoUpdatedFields(anexoFields),
  },
};
